export class ConceptualModel {
    pimIri = null;
    humanLabel = null;
    humanDescription = null;
    classes = {};
}
//# sourceMappingURL=conceptual-model.js.map